import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import MTop from "./MenuTop.module.css";
import { Link, useHistory } from "react-router-dom";
import { getCurrent, getUserInfo } from "../../Api/BarestServices";
import { Bell, Dot } from "react-bootstrap-icons";
import { Modal } from "antd";
import { getNotifInfo } from "../../Api/ClientServices";
import { errorToast } from "../../Toast/Toast";
const MenuTop = (props) => {
  const [currentLocations, setCurrentLocations] = useState("");
  const [Loading, setLoading] = useState(true);
  const [ShowNotification, setShowNotification] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const history=useHistory()
  let AddressHolder = null;
  const CurrentAddres = async () => {
    getCurrent((succ,res)=>{
      if(succ){
        if(res.status===0){
          console.error(res.message)
            setTimeout(() => {
              history.push('/addnewaddress')
            }, 1000);
        }else{
          if (res.status === 0 || res.status === -2) {
            setCurrentLocations("هنوز هیچ آدرسی وارد نشده");
          } else {
            setCurrentLocations(res.address.address);
            localStorage.setItem('userLat',res.address.lat)
            localStorage.setItem('userLon',res.address.lon)
          }
        }
      }else{
        console.error(res)
      }
    })
    setLoading(false);
  };
  useEffect(() => {
    CurrentAddres();
    UserInfo()
    setLoading(false);
  }, [Loading, currentLocations]);
  if (Loading || currentLocations === undefined || currentLocations==="") {
    AddressHolder = "هنوز هیچ آدرسی وارد نشده";
  } else {
    AddressHolder = <div className={MTop.noAddress}>{currentLocations}</div>;
  }
  const [info, setInfo] = useState([]);

  const UserInfo = async () => {
    getUserInfo((succ, res) => {
      if (succ) {
        if (res.status === 0 || res.status === -2) {
          console.warn("کاربر وارد نشده!");
        } else {
          setInfo(res.info);
          localStorage.setItem("wallet", res.info.wallet);
        }
      } else {
        console.error("خطایی در سرور رخ داده است");
      }
    });
  };
  ////////////notification part///////////////
  const showNotifs = () => {
    setShowNotification(true);
    const type = {
      type: "user",
    };
    getNotifInfo(type, (res) => {
      setNotifications(res.notifications);
    });
  };
  const HideModlaHandler = () => {
    setShowNotification(false);
  };
  return (
    // <div>
    <ul className={MTop.menufixed}>
      <Modal
        width={1000}
        open={ShowNotification}
        footer={null}
        closeIcon={HideModlaHandler}
        onOk={HideModlaHandler}
        className={MTop.modal}
      >
        <div className={MTop.allItem}>
          {notifications.length ===0 ? (
            <h2 className={MTop.loading}>پیامی ندارید!</h2>
          ) : (
            notifications.map((item,index) => {
              return (
                <div key={index} className={MTop.eachNotif}>
                  <h2 className={MTop.titleNotif}>{item.title}</h2>
                  <p className={MTop.contentNotif}>{item.body}</p>
                  <Link className={MTop.linkNotif}>{item.click_action}</Link>
                  <h3 className={MTop.dateNotif}>{item.date}</h3>
                </div>
              );
            })
          )}
        </div>
        <div className={MTop.btnHolder}>
          <button onClick={HideModlaHandler} className={MTop.closeBtn}>
            بستن
          </button>
        </div>
      </Modal>
      {localStorage.getItem('phone') ? (
        <li className={`${MTop.zirmenu} ${MTop.flexOne}`} onClick={showNotifs}>
          <div className={MTop.notifHolder}>
            {info.new_notification !=="0" ? <Dot className={MTop.notifAlarm} /> : null}
            <Bell className={MTop.notif} />
          </div>
        </li>
      ) : (
        <li className={`${MTop.zirmenu} ${MTop.flexOne}`}></li>
      )}
      <li className={`${MTop.zirmenu} ${MTop.middle}`}>
        <Link to="/changeaddress">
          <div className={MTop.p}>{AddressHolder}</div>
        </Link>
        <FontAwesomeIcon className={MTop.location} icon={faMapMarkerAlt} />
      </li>
      <li
        onClick={props.openMenu}
        className={`${MTop.zirmenu} ${MTop.flexOne}`}
      >
        <FontAwesomeIcon className={MTop.Bar} icon={faBars} />
      </li>
    </ul>
    // </div>
  );
};

export default MenuTop;
